import { Button, SelectField, TextField } from '../../components';
import type { ResultFilters as Filters } from '../../types/api';
import { CONTENT_TYPE_LABEL, FILTERABLE_CONTENT_TYPES, PLATFORM_LABEL, SORT_LABEL } from './labels';

export interface ResultFiltersProps {
  filters: Filters;
  onChange: <K extends keyof Filters>(key: K, value: Filters[K] | undefined) => void;
  onClear: () => void;
  hasActiveFilters: boolean;
  disabled?: boolean;
}

const PLATFORM_OPTIONS = [
  { value: '', label: 'Todas as plataformas' },
  ...Object.entries(PLATFORM_LABEL).map(([value, label]) => ({ value, label })),
];

const TYPE_OPTIONS = [
  { value: '', label: 'Todos os tipos' },
  ...FILTERABLE_CONTENT_TYPES.map((type) => ({ value: type, label: CONTENT_TYPE_LABEL[type] })),
];

const SORT_OPTIONS = Object.entries(SORT_LABEL).map(([value, label]) => ({ value, label }));

export function ResultFiltersBar({
  filters,
  onChange,
  onClear,
  hasActiveFilters,
  disabled,
}: ResultFiltersProps) {
  return (
    <div className="grid gap-4 rounded-lg border border-border bg-surface p-4 sm:grid-cols-2 lg:grid-cols-4">
      <SelectField
        label="Plataforma"
        value={filters.platform ?? ''}
        disabled={disabled}
        options={PLATFORM_OPTIONS}
        onChange={(event) =>
          onChange('platform', (event.target.value || undefined) as Filters['platform'])
        }
      />
      <SelectField
        label="Tipo"
        value={filters.type ?? ''}
        disabled={disabled}
        options={TYPE_OPTIONS}
        onChange={(event) => onChange('type', (event.target.value || undefined) as Filters['type'])}
      />
      <TextField
        label="Autor"
        placeholder="username ou nome"
        value={filters.author ?? ''}
        disabled={disabled}
        onChange={(event) => onChange('author', event.target.value || undefined)}
      />
      <TextField
        label="Palavra no texto"
        placeholder="filtrar resultados"
        value={filters.keyword ?? ''}
        disabled={disabled}
        onChange={(event) => onChange('keyword', event.target.value || undefined)}
      />

      <div className="flex items-end gap-3 sm:col-span-2 lg:col-span-4">
        <div className="w-full sm:w-56">
          <SelectField
            label="Ordenar por"
            value={filters.sort}
            disabled={disabled}
            options={SORT_OPTIONS}
            onChange={(event) => onChange('sort', event.target.value as Filters['sort'])}
          />
        </div>
        {hasActiveFilters && (
          <Button variant="ghost" size="sm" onClick={onClear} disabled={disabled}>
            Limpar filtros
          </Button>
        )}
      </div>
    </div>
  );
}
